import { z } from "zod";

export const createUserSchema = z.object({
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  email: z.string().email("Invalid email address").min(1, "Email is required"),
  businessRoleId: z.number({ required_error: "Business role is required" }),
});

export const editUserSchema = z.object({
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  email: z.string().email("Invalid email address").min(1, "Email is required"),
  businessRoleId: z.number({ required_error: "Business role is required" }),
});

// Admin schemas include company selection
export const adminCreateUserSchema = z.object({
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  email: z.string().email("Invalid email address").min(1, "Email is required"),
  businessRoleId: z.number({ required_error: "Business role is required" }),
  companyUuid: z.string().min(1, "Company is required"),
});

export const adminEditUserSchema = z.object({
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  email: z.string().email("Invalid email address").min(1, "Email is required"),
  businessRoleId: z.number({ required_error: "Business role is required" }),
  companyUuid: z.string().min(1, "Company is required"),
});

export type CreateUserFormData = z.infer<typeof createUserSchema>;
export type EditUserFormData = z.infer<typeof editUserSchema>;
export type AdminCreateUserFormData = z.infer<typeof adminCreateUserSchema>;
export type AdminEditUserFormData = z.infer<typeof adminEditUserSchema>;